<template>


  <div class="container">
      <h3 class="heading">المديرية</h3>

      <form @submit.prevent="postinfo">
        

<div class="mb-3 input-in-con  ">
           <div v-if="err">
  <div v-if="err.provinec_name"  class="alert alert-danger" role="alert"> {{ err.provinec_name[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">المحافظة</label>
 <select class="form-select " aria-label="Default select example" v-model="formdata.provinec_name" >
  <option disabled selected>اختر المحافظة</option>
  <option  v-for="key in formdata2" >{{key.name}}</option>
</select>
</div>

  <div class="mb-3 input-in-con">
     <div v-if="err">
  <div v-if="err.name"  class="alert alert-danger" role="alert"> {{ err.name[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">الاسم</label>
  <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="ادخل اسم المديرية " v-model="formdata.name">
</div>
<div class="flex last">
  
</div>
<div class="flex last">
  <button class="btn btn-primary">اضافة</button>
</div>
      </form>

  </div>

  

</template>

<script>
import  geturl  from "@/comp/geturl";

export default {
name: "EditDirectorates",
props:['id'],
data(){
  return{
    formdata:{
      provinec_name: '',
      name: '',
      provinec: null,
    },
      temformdata2: null,
     formdata2:null,
     err:null
    
  }
},
methods: {
    postinfo(){
    this.temformdata2 = this.formdata2.filter((e) => {
        return e.name === this.formdata.provinec_name
      })
      if(this.temformdata2.length>0)
       this.formdata.provinec =  this.temformdata2[0].id 
       
      
    fetch(geturl()+"directorate/"+this.id+"/", {
         method: "PUT",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(this.formdata)
      })
      .then(res => res.json())
      .then(data => {if(data.error)
      this.err = data.error.details
      else
            this.$router.push({name:'ViewDirectorates' })
      }) 
    },

},
    mounted(){

           // Get directorate 
       fetch(geturl()+"directorate/",{
      headers: {"Content-Type": "application/json"},
       })
       .then(res => res.json())
       .then(data => {this.formdata = data})
       
       // Get specific directorate
       this.formdata = this.formdata.filter((e)=>{
           return e.id == this.id
       })

     
      
         fetch(geturl()+"provinec/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {this.formdata2 = data
        })
      
    }
}
</script>

<style>

</style>